import { IMember } from "@wingspanhq/users/dist/lib/interfaces";
import type { onboardingApiSpec } from "@wingspanhq/wingspan-api-types";

export const selectorAccountType = (
  monitoredEntity?: onboardingApiSpec.CustomerEntity,
  member?: IMember
) => {
  if (monitoredEntity?.type) {
    return monitoredEntity.type;
  }

  if (member?.profile.company?.taxId) {
    return "Business";
  }

  return "Individual";
};
